var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragHandleDots1SvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#808080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 2.5,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 6.499,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 8.499,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 10.498,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 12.498,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 2.5,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 4.5,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.499,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 8.499,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 10.498,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 12.498,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.499,
    cy: 2.5,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.499,
    cy: 4.5,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.499,
    cy: 6.499,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.499,
    cy: 8.499,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.499,
    cy: 10.498,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.499,
    cy: 12.498,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.499,
    cy: 2.5,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.499,
    cy: 4.5,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.499,
    cy: 6.499,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.499,
    cy: 8.499,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.499,
    cy: 10.498,
    r: 0.6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.499,
    cy: 12.498,
    r: 0.6,
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandleDots1SvgrepoCom);
export default __webpack_public_path__ + "static/media/drag-handle-dots-1-svgrepo-com.41f59d9c20adbebc2ad30e969053fc54.svg";
export { ForwardRef as ReactComponent };